export enum VerificationMethod {
  Sms = 'sms',
  Otp = 'otp',
}
